<template>
  <BCard>
    <div class="flex flex-row justify-between items-center">
      <div class="text-black text-2xl font-medium">
        Verifikasi Data Diri
      </div>
      <div class="flex items-center gap-4">
        <div v-if="data.status !== 'not requested'">
          {{ DAY_MONTH_YEAR(requestDate) }} | {{ TIME(requestDate) }}
        </div>
        <BButton
          variant="primary"
          size="small"
          style="border-radius: 25px !important"
          @click="$bvModal.show('modal-rules')"
        >
          Petunjuk Verifikasi
          <BIcon icon="question-circle" />
        </BButton>
      </div>
    </div>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <ValidationObserver #default="{ invalid }">
        <BRow>
          <BCol lg="6">
            <BCard body-class="flex flex-col gap-3">
              <div>
                <div class="text-black text-xl font-medium">
                  Foto wajah beserta KTP kamu
                  <span
                    v-if="data.status !== 'not requested'"
                    :class="getClassStatus(status.selfie)"
                  >
                    ({{ getLabelStatus(status.selfie) }})
                  </span>
                </div>
                <div class="text-[#828282] text-base">
                  Unggah foto diri beserta KTP kamu
                </div>
              </div>
              <img
                :src="handlePreviewImage('selfie', imageUrl.selfie)"
                alt="Komerce"
                class="rounded-xl"
              >
              <span v-if="checkFormSelfie">
                <div class="text-sm text-center mb-1">
                  Max. 1Mb
                </div>
                <ValidationProvider
                  #default="{ errors }"
                  :rules="{ required: checkFormSelfie ? true : false }"
                >
                  <BFormFile
                    v-model="preview.selfie"
                    :state="errors.length > 0 ? false : null"
                    browse-text="Pilih file"
                    :placeholder="
                      name.selfie ? name.selfie : 'belum ada file yang dipilih'
                    "
                    @change="onUploadFile('selfie', $event)"
                  />
                  <BFormTextarea
                    v-if="status.selfie === 'rejected'"
                    v-model="notes.selfie"
                    class="mt-1"
                    disabled
                    rows="4"
                  />
                  <div
                    v-if="allowFileSize.selfie"
                    class="flex items-center gap-2 mt-1"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                      alt="Komerce"
                      width="15"
                    >
                    <small class="text-primary">Ukuran file terlalu besar</small>
                  </div>
                </ValidationProvider>
              </span>
            </BCard>
          </BCol>
          <BCol lg="6">
            <BCard body-class="flex flex-col gap-3">
              <div>
                <div class="text-black text-xl font-medium">
                  Foto KTP kamu
                  <span
                    v-if="data.status !== 'not requested'"
                    :class="getClassStatus(status.idCard)"
                  >
                    ({{ getLabelStatus(status.idCard) }})
                  </span>
                </div>
                <div class="text-[#828282] text-base">
                  Unggah foto KTP kamu
                </div>
              </div>
              <img
                :src="handlePreviewImage('idCard', imageUrl.idCard)"
                alt="Komerce"
                class="rounded-xl"
              >
              <span v-if="checkFormIdCard">
                <div class="text-sm text-center mb-1">
                  Max. 1Mb
                </div>
                <ValidationProvider
                  #default="{ errors }"
                  :rules="{ required: checkFormIdCard ? true : false }"
                >
                  <BFormFile
                    v-model="preview.idCard"
                    :state="errors.length > 0 ? false : null"
                    browse-text="Pilih file"
                    :placeholder="
                      name.idCard ? name.idCard : 'belum ada file yang dipilih'
                    "
                    @change="onUploadFile('idCard', $event)"
                  />
                  <BFormTextarea
                    v-if="status.idCard === 'rejected'"
                    v-model="notes.idCard"
                    class="mt-1"
                    disabled
                    rows="4"
                  />
                  <div
                    v-if="allowFileSize.idCard"
                    class="flex items-center gap-2 mt-1"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                      alt="Komerce"
                      width="15"
                    >
                    <small class="text-primary">Ukuran file terlalu besar</small>
                  </div>
                </ValidationProvider>
              </span>
            </BCard>
          </BCol>
        </BRow>
        <BRow>
          <BCol lg="12">
            <div class="flex flex-row items-center">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user.svg"
                alt="Komerce"
              >
              <div class="ml-[10px]">
                <h5 class="text-black font-medium text-xl mb-0">
                  Informasi Data Partner
                </h5>
                <div>
                  <sup class="text-primary">*</sup>
                  <span>Pastikan dokumen yang di-upload persis dengan informasi data partner</span>
                </div>
              </div>
            </div>
          </BCol>
        </BRow>
        <BOverlay
          :show="loading"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <BRow class="justify-center items-center mt-3 gap-[10px]">
            <BCol
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                Pengguna Product
              </BCol>
              <BCol
                lg="6"
                class="flex items-center"
              >
                <div
                  v-for="(product, key) in productList"
                  :key="key"
                >
                  <img
                    :src="product.url_image"
                    alt="Komerce"
                    width="30"
                  >
                </div>
              </BCol>
            </BCol>
            <BCol
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                NIK
              </BCol>
              <BCol lg="6">
                <ValidationProvider
                  #default="{ errors }"
                  name="NIK"
                  rules="required|min:16"
                >
                  <BFormInput
                    v-model="kycInformation.nik"
                    :state="errors.length > 0 ? false : null"
                    :disabled="isDisabledIdentityNumber ? true : false"
                    maxlength="16"
                    placeholder="Masukan NIK kamu"
                    @keypress="isNumber($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </BCol>
            </BCol>
            <BCol
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                Nama
              </BCol>
              <BCol lg="6">
                <BInput
                  v-model="kycInformation.name"
                  disabled
                />
              </BCol>
            </BCol>
            <BCol
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                Email
              </BCol>
              <BCol lg="6">
                <BInput
                  v-model="kycInformation.email"
                  disabled
                />
              </BCol>
            </BCol>
            <BCol
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                No. Ponsel
              </BCol>
              <BCol lg="6">
                <BInput
                  v-model="kycInformation.phone"
                  disabled
                />
              </BCol>
            </BCol>
          </BRow>
        </BOverlay>
        <BRow class="gap-2 px-2 justify-end mt-2">
          <BButton
            variant="outline-primary"
            @click="$router.back()"
          >
            Kembali
          </BButton>
          <BButton
            type="submit"
            :variant="invalid ? 'secondary' : 'primary'"
            :disabled="invalid || disabled"
            @click="$bvModal.show(idModal)"
          >
            Ajukan Verifikasi
          </BButton>
        </BRow>
      </ValidationObserver>
    </BOverlay>

    <ModalVerificationKyc
      :id-modal="idModal"
      :title="'Pengajuan Verifikasi KTP'"
      :desc="'Pastikan bahwa file KTP dan Selfie yang anda ajukan telah benar'"
      :source="'verif'"
      :loading="loadingSubmit"
      :submit="onSubmit"
    />
    <RulesVerification />
  </BCard>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min } from '@validations'
import { newAxiosIns } from '@/libs/axios'
import { DAY_MONTH_YEAR, TIME } from '@/libs/formatDate'
import { isNumber } from '@/libs/helpers'
import RulesVerification from './components/RulesVerification.vue'
import ModalVerificationKyc from './components/ModalVerificationKyc.vue'
import { getLabelStatus, getClassStatus } from './config'

export default {
  components: {
    ValidationObserver, ValidationProvider, RulesVerification, ModalVerificationKyc,
  },
  data() {
    return {
      getLabelStatus,
      getClassStatus,
      DAY_MONTH_YEAR,
      TIME,
      isNumber,
      preview: {
        selfie: null,
        idCard: null,
      },
      name: {
        selfie: null,
        idCard: null,
      },
      allowFileSize: {
        selfie: false,
        idCard: false,
      },
      allowFileExt: {
        selfie: false,
        idCard: false,
      },
      size: {
        selfie: 0,
        idCard: 0,
      },
      required,
      min,
      loadingSubmit: false,
      loading: false,
      data: null,
      kycInformation: {},
      productList: [],
      imageUrl: {
        selfie: '',
        idCard: '',
      },
      status: {
        selfie: '',
        idCard: '',
      },
      notes: {
        selfie: '',
        idCard: '',
      },
      idModal: 'modal-confirm-kyc',
      requestDate: '',
    }
  },
  computed: {
    checkFormSelfie() {
      const confitions = [
        this.status.selfie === 'rejected',
        this.data.status === 'not requested',
      ]
      return confitions.some(condition => condition)
    },
    checkFormIdCard() {
      const conditions = [
        this.status.idCard === 'rejected',
        this.data.status === 'not requested',
      ]
      return conditions.some(condition => condition)
    },
    disabled() {
      const conditions = [
        this.allowFileSize.selfie,
        this.allowFileSize.idCard,
        this.allowFileExt.idCard,
        this.allowFileExt.selfie,
        this.loadingSubmit,
      ]
      return conditions.some(condition => condition)
    },
    isDisabledIdentityNumber() {
      return ['approved', 'requested'].includes(this.data.status)
    },
  },
  mounted() {
    this.getFile()
  },
  methods: {
    async getFile() {
      this.loading = true
      const url = '/auth/api/v1/partner/request-verification-ktp/latest-history'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data = data
          this.requestDate = data.requested_date
          this.status.selfie = data.ktp_face_picture.status
          this.status.idCard = data.ktp_picture.status
          this.imageUrl.selfie = data.ktp_face_picture.url
          this.imageUrl.idCard = data.ktp_picture.url
          this.notes.selfie = data.ktp_face_picture.notes
          this.notes.idCard = data.ktp_picture.notes
          this.kycInformation = data.info_data_partner
          this.productList = data.product_partner
          this.loading = false
        })
        .catch(err => {
          const { response: { data: { data } } } = err
          this.data = data
          this.loading = false
        })
    },
    async onSubmit() {
      this.loadingSubmit = true
      const url = '/auth/api/v1/partner/request-verification-ktp'
      const formData = new FormData()

      if (this.status.selfie === 'approved') {
        formData.append('image_ktp_base_64', this.preview.idCard)
        formData.append('request_nik', this.kycInformation.nik)
      } else if (this.status.idCard === 'approved') {
        formData.append('image_ktp_with_face_base_64', this.preview.selfie)
        formData.append('request_nik', this.kycInformation.nik)
      } else {
        formData.append('image_ktp_base_64', this.preview.idCard)
        formData.append('image_ktp_with_face_base_64', this.preview.selfie)
        formData.append('request_nik', this.kycInformation.nik)
      }
      await newAxiosIns
        .post(url, formData)
        .then(() => {
          this.loadingSubmit = false
          this.$bvModal.hide(this.idModal)
          this.$toast_success({
            message: 'Berhasil mengajukan Verifikasi KTP. Silahkan tunggu konfirmasi lebih lanjut selama 1x24 jam',
          })
          this.$router.back()
        })
        .catch(() => {
          this.loadingSubmit = false
          this.$toast_error({ message: 'Gagal mengajukan Verifikasi KTP' })
        })
    },
    onUploadFile(type, event) {
      const { target } = event
      const file = target.files[0]
      const fileSize = file.size
      const fileType = file.type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      const isValidType = allowedTypes.includes(fileType)

      if (fileSize > 1024 * 1024) {
        this.allowFileSize[type] = true
      } else {
        this.allowFileSize[type] = false
      }

      if (!isValidType) {
        this.allowFileExt[type] = true
        this.$toast_error({ message: 'File yang kamu masukan harus berupa format image' })
      } else if (file) {
        this.allowFileExt[type] = false
        const reader = new FileReader()

        reader.onload = e => {
          this.preview[type] = e.target.result
        }

        reader.readAsDataURL(file)
      } else {
        this.preview[type] = null
      }
    },
    handlePreviewImage(type, image) {
      if (this.preview[type] !== null) { return this.preview[type] }
      if (this.data.status !== 'not requested') { return [image] }
      return 'https://storage.googleapis.com/komerce/assets/illustration/placeholder-selfie.svg'
    },
  },
}
</script>
